import { useState } from "react";

function useTableLoading() {
  const [tableLoading, setTableLoading] = useState<boolean>(false);

  return {
    tableLoading,
    setTableLoading
  };
}

export default useTableLoading;
